import { Link } from 'react-router-dom';

function FloatingControls({
    tableLink,
    enableCancel,
    onCancel,
    formLink,
    onFormLinkClick,
    addNewLabel = 'Add New',
    homeLink = '/Home/schedule',
    showSave = true,
    enablePrint = false,
    onPrint,
    enableDelete = false,
    onDelete,
}) {

    const bottom_margin = '30px';

    return (

        <>
            <div className="floating-button-bar">
                <div className="social-btn"  >   
                    <ul className="text-right" style={{flexDirection: "column"}}>
                        {showSave ? (
                        <li className="text-center" style={{marginBottom: bottom_margin}}>
                            <button type="submit" className="google" style={{borderColor:"transparent"}} title="SAVE/UPDATE">
                            <i className="fa fa-floppy-o"></i><i className="fa fa-floppy-o"></i>
                            </button>
                        </li>
                        ) : null}
                        { (enableCancel) ? 
                            <li className="text-center" style={{marginBottom: bottom_margin}} title="CANCEL">
                                <Link to="" onClick={onCancel} className="facebook">
                                <i className="fa fa-ban"></i><i className="fa fa-ban"></i>
                                </Link>
                            </li> : ''
                        }
                        {enablePrint ? (
                            <li className="text-center" style={{marginBottom: bottom_margin}} title="PRINT">
                                <Link to="" onClick={(event) => { event.preventDefault(); onPrint?.(event); }} className="google">
                                <i className="fa fa-print"></i><i className="fa fa-print"></i>
                                </Link>
                            </li>
                        ) : null}
                        {enableDelete ? (
                            <li className="text-center" style={{marginBottom: bottom_margin}} title="DELETE">
                                <Link to="" onClick={(event) => { event.preventDefault(); onDelete?.(event); }} className="facebook">
                                <i className="fa fa-trash"></i><i className="fa fa-trash"></i>
                                </Link>
                            </li>
                        ) : null}
                        {formLink || onFormLinkClick ? (
                            <li className="text-center" style={{marginBottom: bottom_margin}} title={addNewLabel.toUpperCase()}>
                                {onFormLinkClick ? (
                                    <Link
                                        to={formLink || '#'}
                                        className="google"
                                        onClick={(event) => {
                                            event.preventDefault();
                                            onFormLinkClick(event);
                                        }}
                                    >
                                        <i className="fa fa-plus"></i><i className="fa fa-plus"></i>
                                    </Link>
                                ) : (
                                    <Link to={formLink} className="google">
                                        <i className="fa fa-plus"></i><i className="fa fa-plus"></i>
                                    </Link>
                                )}
                            </li>
                        ) : null}
                        {tableLink ? (
                        <li className="text-center" style={{marginBottom: bottom_margin}} title="TABLE">
                            <Link to={tableLink} className="facebook">
                            <i className="fa fa-eye"></i><i className="fa fa-eye"></i>
                            </Link>
                        </li>
                        ) : null}
                        <li className="text-center" title="HOME">
                            <Link to={homeLink} className="twitter">
                            <i className="fa fa-home"></i><i className="fa fa-home"></i>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}

export default FloatingControls;
